/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_No_ChangesInputs */

const es_common_no_changes = /** @type {(inputs: Common_No_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sin cambios`)
};

const en_common_no_changes = /** @type {(inputs: Common_No_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No changes`)
};

/**
* | output |
* | --- |
* | "No changes" |
*
* @param {Common_No_ChangesInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const common_no_changes = /** @type {((inputs?: Common_No_ChangesInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_No_ChangesInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_common_no_changes(inputs)
	return en_common_no_changes(inputs)
});
export { common_no_changes as "common.no_changes" }